import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AgGridModule } from "ag-grid-angular";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { DropdownModule } from "primeng/dropdown";
import { DateRangeFormComponent } from "./date-range-form.component";
import { GridActionComponent } from "./grid-action.component";
import { RosterTypePreviewComponent } from "./roster-type-preview.component";
import { SafeHtmlPipe } from "./safe-html.pipe";

@NgModule({
  declarations:[
    RosterTypePreviewComponent,
    DateRangeFormComponent,
    SafeHtmlPipe,
    GridActionComponent
  ],
  imports:[
    CommonModule,
    FormsModule,

    ButtonModule,
    CalendarModule,
    DropdownModule,
    AgGridModule,
  ],
  exports:[
    RosterTypePreviewComponent,
    DateRangeFormComponent,
    SafeHtmlPipe,
    GridActionComponent
  ]
})
export class SharedModule{}